import React, { useEffect, useState } from "react";
import { getContactCount } from "../utils/contact";
import { getAllBlogs } from "../utils/blogs";

const DashboardContent = () => {
  const [setBlogsCount] = useState(0);

  const [contactStats, setContactStats] = useState({
    week: 0,
    month: 0,
    total: 0,
  });

  const fetchContactStats = async () => {
    try {
      const response = await getContactCount();
      setContactStats({
        week: response.data.this_week,
        month: response.data.this_month,
        total: response.data.total,
      });
    } catch (error) {
      console.error("Error fetching contact stats:", error);
    }
  };

  const fetchBlogCount = async () => {
    try {
      const response = await getAllBlogs();
      setBlogsCount(response.data.length);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };
  
  useEffect(() => {
    fetchContactStats();
    fetchBlogCount();
  }, []);

  return (
    <div className="px-4 py-6 sm:px-6 md:px-8 lg:px-12">
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-6">
        Dashboard Overview
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="bg-white shadow-md rounded-xl p-6 border-t-4 border-[#0D283F]">
          <h2 className="text-gray-600 text-lg font-medium mb-2">
            Contacts This Week
          </h2>
          <p className="text-3xl font-bold text-blue-600">
            {contactStats.week}
          </p>
        </div>

        <div className="bg-white shadow-md rounded-xl p-6 border-t-4 border-[#0D283F]">
          <h2 className="text-gray-600 text-lg font-medium mb-2">
            Contacts This Month
          </h2>
          <p className="text-3xl font-bold text-green-600">
            {contactStats.month}
          </p>
        </div>

        <div className="bg-white shadow-md rounded-xl p-6 border-t-4 border-[#0D283F]">
          <h2 className="text-gray-600 text-lg font-medium mb-2">
            All-Time Contacts
          </h2>
          <p className="text-3xl font-bold text-purple-600">
            {contactStats.total}
          </p>
        </div>

        {/* <div className="bg-white shadow-md rounded-xl p-6 border-t-4 border-blue-500">
          <h2 className="text-gray-600 text-lg font-medium mb-2">Blogs Count</h2>
          <p className="text-3xl font-bold text-purple-600">{blogsCount}</p>
        </div> */}
      </div>
    </div>
  );
};

export default DashboardContent;
